import { Typography } from '@/shared/ui/typography'

import { type FC } from 'react'

import { SideMenuLink } from './SideMenuLink'
import type { SideMenuItemProps } from './types'

/**
 * SideMenu.Item — a level-1 leaf navigation item.
 *
 * Renders as a NavLink when `to` is provided (active state via the router),
 * or as a button when `onClick` is provided. The label is revealed by the
 * parent rail expanding (pinned or hover preview on desktop).
 *
 * The rail row primitive intentionally does not reuse `<Button>` from the DS:
 * Button's `WithIcon` layout collapses icon and label into an inline pair,
 * which breaks the rail's fixed 52px icon column that keeps every row's icon
 * aligned across collapsed/expanded states. `.btn` also forces `uppercase`/
 * `tracking-widest` styling appropriate for CTAs but wrong for nav labels.
 */
export const SideMenuItem: FC<SideMenuItemProps> = ({ icon, label, to, onClick, end, active }) => (
  <SideMenuLink
    to={to}
    onClick={onClick}
    end={end}
    active={active}
    baseClassName="side-menu-item"
    trackActive
  >
    <span className="side-menu-item-content">
      <span className="side-menu-item-icon">{icon}</span>
      <span className="side-menu-item-label">
        <Typography type="paragraph" variant="md">
          {label}
        </Typography>
      </span>
    </span>
  </SideMenuLink>
)

SideMenuItem.displayName = 'SideMenuItem'
